export const dateOnLoad = new Date();
let currentDate = dateOnLoad;
export function initCurrentDate(mockDate) {
    currentDate =
        typeof mockDate === "string"
            ? new Date(decodeURIComponent(mockDate).replaceAll("+", " "))
            : dateOnLoad;
}
export function refreshCurrentDate() {
    const diff = new Date().valueOf() - dateOnLoad.valueOf();
    return new Date(currentDate.valueOf() + diff);
}
export function getCurrentDate() {
    return currentDate;
}
